// extracted by mini-css-extract-plugin
module.exports = {"Container":"Jumboton_Container__26IkE","TitlePanel":"Jumboton_TitlePanel__1LPoe","DescPanel":"Jumboton_DescPanel__2rK0W"};